import { useContext, useState } from "react";
import { GraphContext } from "./data";
import { CosmoComponentSimple } from "./cosmo-component-simple";
import { CosmographProvider } from "@cosmograph/react";
import { groupKeysList, LinkType, NodeType, Point3D, searchGroupTips } from "./model";
import React from "react";
import CloudCanvas from "../components/CloudCanvas";

export const SearchPanel = (props: {
  pointsData: Point3D[];
  searchText: string;
  searchGroup: string;
  setSearchText: (data: string) => void;
  setSearchGroup: (data: string) => void;
}) => {
  const [search, setSearch] = useState<boolean>(false);
  const [searchTips, setSearchTips] = useState<string>('');
  // const [nodes, setNodes] = React.useState<Point3D[]>([]);

  // const filterNodes = (value: string, group: string) => {
  //   const newNodes = props.pointsData.filter((d: any) => {
  //     return (
  //       d[`:${group}Name`].toLowerCase().indexOf(value) >= 0
  //     );
  //   });
  //   return { nodes: newNodes };
  // };
  const onClick = () => {
    const text = document.getElementById("search_text") as HTMLInputElement;
    const group = (document.querySelector(".search-group-select") as HTMLSelectElement).value;
    const value = text.value.trim().toLowerCase();
    if (!value) {
      alert("Please input the text to search.");
      return;
    }

    // const newData = filterNodes(value, group);
    // if (newData.nodes.length === 0) {
    //   alert("No data found.");
    //   return;
    // }

    if (group !== 'all') {
      setSearchTips(searchGroupTips[group as keyof typeof searchGroupTips]);
    }

    setSearch(true);
    props.setSearchText(value);
    props.setSearchGroup(group);
    // setNodes(newData.nodes);
  };

  const onClose = () => {
    // const text = document.getElementById("search_text") as HTMLInputElement;
    // text.value = "";
    setSearch(false);
    props.setSearchText("");
    props.setSearchGroup("");
  };

  const onSearchGroup = (group: string) => {
    if (group !== 'all') {
      setSearchTips(searchGroupTips[group as keyof typeof searchGroupTips]);
    } else {
      setSearchTips('');
    }
  };
  return (
    <div className="search-panel">
      <input type="text" placeholder="Search" id="search_text" />
      <select className="search-group-select" onChange={(e) => onSearchGroup(e.target.value)}>
        <option value="all">All</option>
        {groupKeysList.map((key) => <option key={key} value={key}>{key}</option>)}
      </select>
      <button onClick={onClick}>Search</button>
      {search && <button onClick={onClose}>X</button>}
      {searchTips && <div className="search-tips">{searchTips}</div>}
      {/* {search && (
        <div className="search-panel-on">
          <div className="close-link" onClick={onClose}>
            X
          </div>
          <CloudCanvas
            data={nodes}
            paused={false}
            onPointDoubleClick={() => { }}
            onHover={() => { }}
            showUnknown={false}
          // showPred={activePfamSource === 'pred'}
          />
        </div>
      )} */}
    </div>
  );
};
